import { MESSAGES_COPY } from '../messages/COPY';
import { PLACEHOLDERS_COPY } from '../placeholders/COPY';

export const LAST_NAME = {
	MIN_LENGTH: 1,
	PATTERN: /^[a-zA-Z, ',~`-]+$/u,
	PLACEHOLDER: PLACEHOLDERS_COPY.LAST_NAME,
	REQUIRED_MESSAGE: MESSAGES_COPY.PLEASE_ENTER_YOUR_LAST_NAME
};
